import { AddTransactionRequest } from "@syla/shared/types/requests/TransactionRequests";
import axios from "axios";

export const addOrder = async (props: AddTransactionRequest): Promise<void> => {
  const { accountId, ...rest } = props;
  await axios.post(`/accounts/${accountId}/orders`, rest);
};
